<template>
  <div
      style="margin-bottom: 20px"
      class="col-md-6 col-sm-12"
      v-for="trip in tripsWithManualAndPredictedTags"
      :key="trip.id"
    >
      <div class="card">
        <div class="card-body">
          <div class="row" style="margin-bottom: 30px">
            <div class="col-md-6" style="margin-bottom: 15px">
              Start Time: {{ trip.startTime }} <br />
              Start Timezone: {{ trip.startTimeZone }} <br />
              End Time: {{ trip.endTime }} <br />
              End Timezone: {{ trip.startTimeZone }} <br />
            </div>
            <div class="col-md-6" style="margin-bottom: 15px">
              Distance: {{ trip.distance }} <br />
              Fuel: {{ trip.fuel }} <br />
              Emission (CO2): {{ trip.co2 }} <br />
              Fuel Cost: {{ trip.fuelCost }} <br />
            </div>

            <div class="col-md-6" style="margin-bottom: 15px">
              Number of Trip Details: {{ trip.numberOfTripDetails }} <br />
              Number of Events: {{ trip.numberOfEvents }} <br />
              Litres / 100 KM: {{ trip.litresPerHundredKm }} <br />
              Average Speed: {{ trip.averageSpeed }} <br />
            </div>

            <div class="col-md-6" style="margin-bottom: 15px">
              Device Serial Number: {{ trip.deviceSerialNumber }} <br />
              Firmware Version: {{ trip.firmwareVersion }} <br />
              Mobile App Version: {{ trip.MobileAppVersion }} <br />
              Mobile Handset: {{ trip.mobileHandset }} <br />
            </div>
          </div>

          <div class="row">
            <h5>Tags</h5>
            <div class="col-md-6">
              <table class="table">
                <tbody>
                <tr>
                  <td colspan="2"><h6>Manual Tags</h6></td>
                </tr>
                <tr>
                  <td>Personal Tags</td>
                  <td>
                    <span v-if="trip.manualTags['personal']">
                      {{ trip.manualTags['personal'].map((tag) => tag.name).join(',') }}
                    </span>
                    <span v-else>No Tags.</span>
                  </td>
                </tr>
                <tr>
                  <td>Business Client Tags</td>
                  <td>
                    <span v-if="trip.manualTags['business-client']">
                      {{ trip.manualTags['business-client'].map((tag) => tag.name).join(',') }}
                    </span>
                    <span v-else>No Tags.</span>
                  </td>
                </tr>
                <tr>
                  <td>Business Purpose Tags</td>
                  <td>
                    <span v-if="trip.manualTags['business-purpose']">
                      {{ trip.manualTags['business-purpose'].map((tag) => tag.name).join(',') }}
                    </span>
                    <span v-else>No Tags.</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <table class="table">
                <tbody>
                <tr>
                  <td colspan="2"><h6>Predicted Tags</h6></td>
                </tr>
                <tr>
                  <td>Personal Tags</td>
                  <td>
                    <span v-if="trip.predictedTags['personal']">
                      {{ trip.predictedTags['personal'].map((tag) => tag.name).join(',') }}
                    </span>
                    <span v-else>No Tags.</span>
                  </td>
                </tr>
                <tr>
                  <td>Business Client Tags</td>
                  <td>
                    <span v-if="trip.predictedTags['business-client']">
                      {{ trip.predictedTags['business-client'].map((tag) => tag.name).join(',') }}
                    </span>
                    <span v-else>No Tags.</span>
                  </td>
                </tr>
                <tr>
                  <td>Business Purpose Tags</td>
                  <td>
                    <span v-if="trip.predictedTags['business-purpose']">
                      {{ trip.predictedTags['business-purpose'].map((tag) => tag.name).join(',') }}
                    </span>
                    <span v-else>No Tags.</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'VehicleTripsGrid',
  props: {
    tripsWithManualAndPredictedTags:[]
  }
}
</script>